import React, { useState } from 'react'
import { Grid, Typography, Box, makeStyles, Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import SuhaGridItem from '../Suha/SuhaGridItem'
import SuhaBubble from "../Suha/SuhaBubble";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.dark,
    padding: '5vh 5vw',
    minHeight: '100vh',
  },
  buttons: {
      display: 'flex',
      marginTop: theme.spacing(2),
  },

  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
    nextButton: {
        backgroundColor: '#256081',
        color: 'white',
        borderRadius: '10px',
        padding: "10px 10px",
        marginTop: theme.spacing(3),
        // display: 'flex',
        margin: 'auto',
        fontSize: '1.5em',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
    },
  logo: {
    maxWidth: '80vw',
  },
  body1: {
    colorTextPrimary: {
      color: 'red',
      backgroundColor: 'red',
    },
  },
  suha: {
    margin: '5vh',
    maxWidth: '33vw',
  },
  gridContainer: {},
}))

export default function Intro(props: any) {
  const classes = useStyles()
  const history = useHistory()

  const nextButton = (fx: any) => {
    return (
      <React.Fragment>
        <div className={classes.buttons}>
          <Button
              fullWidth={true}
              variant="contained"
              color="primary"
              onClick={fx}
              className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    )
  }

  const handleNext = () => {
    history.push('/step')
  }

  const items = () => {
    //TODO no side effects with map
    const text = [
      `Just a quick reminder that everything you text here will remain strictly confidential except unless it's a matter of safety.`,
      `Your current treatment (if any) will NOT be affected in any way by your participation in <em>RecoveryPad</em>.`,
      `That said, it could really help you with your opioid use, so thanks for participating.`,
    ]
    return text.map((value: any, idx: number) => {
      return (
        <Grid item key={idx}>
          <Typography ><div dangerouslySetInnerHTML={{ __html: value }}></div></Typography>
          <br />
        </Grid>
      )
    })
  }

  return (
    <Box p={4} className={classes.root}>
      <Grid container
            justify={'center'}
      >
        <Grid item></Grid>
        <Grid item>
            <SuhaBubble position={1}/>
        </Grid>
        <Grid item container>
          {items()}
        </Grid>
        <Grid item xs={12}>{nextButton(handleNext)}</Grid>
      </Grid>
    </Box>
  )
}
